import React, { Component } from 'react';
import autobind from 'class-autobind';
import map from 'lodash/map';

import SiteListUI from './site_list_ui.jsx';
import Page from 'zoomforth_zf/models/page.js';

class SiteList extends Component {

  constructor(props) {
    super(props);
    autobind(this);

    this.state = {
      sites: []
    };
  }

  componentDidMount(){
    this.setState({ 
      sites: map(this.props.sites, (site) => {
        const model = new Page(site);
        model.fetch();
        return { ...site, model };
      }) 
    });

  }

  render() {
    return (<SiteListUI {...{ ...this.props, ...this.state }} />);
  }
}

export default SiteList;